import { Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { Router } from '@angular/router';

import { Api } from './api';
import { Endpoint } from './endpoint';
import { Token } from './token';
import { Modal } from './modal';
import { ModalOptions } from '../../shared/utils/types';
import { BaseModal } from '../../shared/components/modals/base-modal/base-modal';

@Injectable({
  providedIn: 'root'
})
@Injectable({ providedIn: 'root' })
export class AuthStore {
  user = signal<any | null>(null);
  isAuthenticated = signal(false);

  constructor(
    private api: Api,
    private tokenService: Token,
    private endpoints: Endpoint,
    private router: Router,
    private modalService: Modal,
  ) {
    // Initialize based on existing token
    const token = this.tokenService.getToken();
    if (token) { this.isAuthenticated.set(true); this.user.set(this.getDummyUser()); }
  }

  login(credentials: { username: string; password: string }) {
    const { username, password } = credentials;

    const loginData = {
      username,
      password,
      loginType: 1, // 1 = login via web
      signature: ''
    };
    this.router.navigate(['/accounts']);
    this.tokenService.setToken("e467fe3f7a16e1b5bc25562b3c17f688ec52cda802c3f9c5cd325bb1ca0934b2"); //todo remove this it is dummy
    this.isAuthenticated.set(true);
    this.setUserRole();

    return this.api
      .post<{ token: string; user: any }>(this.endpoints.endpoints.login, loginData)
      .pipe(
        tap(res => {
          if (res?.token) {
            this.tokenService.setToken(res.token);
            this.user.set(res.user);
            this.isAuthenticated.set(true);
          }
        })
      );
  }


  logout() {
    this.tokenService.clearToken();
    this.user.set(null);
    this.isAuthenticated.set(false);
    this.router.navigate(['/']);
    this.logoutModal();
    this.clearUserRole();
  }

  get currentUser() {
    return this.user();
  }

  get isLoggedIn() {
    return this.isAuthenticated();
  }

  getUser() {
    // return dummy user if not logged in for development
    return this.user() ?? this.getDummyUser();
  }

  private getDummyUser() {
    return {
      id: 1,
      name: 'Zahin Syaheer',
      email: 'zahin@example.com',
      profileImage: '', // leave empty to show initials
      role: 'Admin',
    };
  }

  logoutModal() {
    const baseModalOptions: ModalOptions = {
      backdropClosable: false,
      showCancelButton: false,
      showConfirmButton: true,
      textConfrimButton: 'LOGOUT.OKAY',
      size: 'lg',
      headerIconPath: 'assets/icons/info-check.svg',
      title: 'LOGOUT.LOGOUT_TITLE',
      onConfirm: () => {
        this.modalService.close();
      },
    };
    this.modalService.open(BaseModal, baseModalOptions);
  }

  setUserRole() {
    localStorage.setItem('userRole', 'maker');
  }

  clearUserRole() {
    localStorage.removeItem('userRole');
  }
}
